<template>
  <v-row align="center" justify="center">
    <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
      <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="col-md-10 col-lg-8 home-box">
      <v-card v-if="!loading && club">
        <v-card-title class="white--text primary d-flex align-center">
          <span>
            <h3 class="mb-0">{{ club.name }}</h3>
          </span>
        </v-card-title>
        <v-card-text class="text-center py-6">
          <v-icon x-large color="orange" class="mb-3">mdi-account-multiple</v-icon>
          <div class="title">Member directory coming soon</div>
          <div class="body-1 mt-2">
            This page belongs to {{ club.name }}.
          </div>
        </v-card-text>
      </v-card>

      <v-card v-if="!loading && !club && error">
        <v-card-text class="text-center py-8">
          <v-icon x-large color="orange" class="mb-3">mdi-account-alert</v-icon>
          <div class="title">Club not found</div>
          <div class="body-1 mt-2">
            The club you are looking for could not be found or may be marked inactive.
          </div>
        </v-card-text>
      </v-card>
    </div>
  </v-row>
</template>

<script>
import { CommonService } from "../../services/common-service.js";

export default {
  name: "PublicClubMembers",
  data: function() {
    return {
      club: null,
      error: false,
      loading: false,
    };
  },
  mounted() {
    this.getClub();
  },
  methods: {
    getClub() {
      const uuid = this.$route.params.uuid;
      if (!uuid) {
        this.error = true;
        return;
      }
      this.loading = true;
      CommonService.getPublicClubMembers(uuid)
        .then((response) => {
          this.loading = false;
          this.club = response.data.club;
        })
        .catch(() => {
          this.loading = false;
          this.error = true;
        });
    },
  },
};
</script>